import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

export const getTransactionsReferral = async (parentId: number) => {
    try {
        const response = await axios.get(`${API_URL}/transactions/referral/${parentId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching transactions:', error);
        throw error;
    }
};

export const getSponsorships = async () => {
    try {
        const response = await axios.get(`${API_URL}/sponsorship/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching sponsorships:', error);
        throw error;
    }
};

export const updateTransaction = async (transactionId: number, data: any) => {
    try {
        const response = await axios.put(`${API_URL}/transactions/${transactionId}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating transaction:', error);
        throw error;
    }
};


export const getTransactions = async (userId: number) => {
    try {
        const response = await axios.get(`${API_URL}/transactions/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching transactions:', error);
        throw error;
    }
};